import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent,
  Divider, InputLabel, CardHeader, MenuItem
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePdf';
import Chip from '@material-ui/core/Chip';
import xlsx from 'json-as-xlsx';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
  chip: {
    alignContent: 'center',
    margin: theme.spacing(3),
    backgroundColor: '#ADD8E6',
    color: 'black',
  },

}));

const screenCode = 'CUSTOMERSUPPLIERCARD';

export default function CustomerSupplierCard(props) {
  const [title, setTitle] = useState("Leaf Supplier Card Details Report");
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routes, setRoutes] = useState();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [customerDetail, setCustomerDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    year: '',
    month: '',
    registrationNumber: '',
  });
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    routeName: "0",
    year: '',
    month: '',
    registrationNumber: ''
  });
  const [csvHeaders] = useState([]);
  const [customerName, setCustomerName] = useState("");
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();
  const [showTable, setShowTable] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [totals, setTotals] = useState({
    superTotal: '0',
    normalTotal: '0',
    totalWeight: '0'
  });

  useEffect(() => {
    trackPromise(
      getPermission()
    );
    trackPromise(
      getGroupsForDropdown()
    );
  }, []);

  useEffect(() => {
    setSelectedDate(new Date());
    getFactoriesForDropdown();
    setCustomerData([]);
  }, [customerDetail.groupID]);

  useEffect(() => {
    setSelectedDate(new Date());
    setCustomerData([]);
    trackPromise(
      getRoutesByFactoryID()
    )
  }, [customerDetail.factoryID]);

  useEffect(() => {
    setCustomerData([]);
  }, [customerDetail.routeID]);

  useEffect(() => {
    setCustomerName("");
    setCustomerData([]);
  }, [customerDetail.registrationNumber]);

  useEffect(() => {
    setCustomerData([]);
  }, [customerName]);

  useEffect(() => {
    setCustomerData([]);
  }, [selectedDate]);

  useEffect(() => {
    const newTotals = calculateTotals();
    setTotals(newTotals);
  }, [customerData]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCUSTOMERSUPPLIERCARD');
    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setCustomerDetail({
      ...customerDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  const getColumnDays = (columnIndex) => {
    const startDay = columnIndex * 8;
    const endDay = startDay + 31;
    return { startDay, endDay };
  };

  const groupDataByDay = () => {
    const daysData = {};

    for (let day = 1; day <= 31; day++) {
      daysData[day] = [];
    }

    const groupedByDate = {};
    customerData.forEach(item => {
      const date = new Date(item.cropCollectedDate).toLocaleDateString('en-CA');
      if (!groupedByDate[date]) {
        groupedByDate[date] = {
          superNetWeight: 0,
          normalNetWeight: 0,
          date: date
        };
      }
      groupedByDate[date].superNetWeight += item.superNetWeight || 0;
      groupedByDate[date].normalNetWeight += item.normalNetWeight || 0;
    });

    Object.values(groupedByDate).forEach(item => {
      const day = new Date(item.date).getDate();
      if (daysData[day]) {
        daysData[day].push(item);
      }
    });

    return daysData;
  };


  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(customerDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(customerDetail.factoryID);
    setRoutes(routeList);
  }
  async function getCustomerNameByCustomerID() {
    const result = await services.getCustomerDetailsNameAndRouteName(customerDetail.groupID, customerDetail.factoryID, customerDetail.registrationNumber)
    if (result.statusCode == "Success") {
      setCustomerName(result.data.customerName);
    } else {
      setCustomerName("");
      alert.error("Invalid Registration Number");
    }
  }

  async function getCustomerDetails() {
    let model = {
      groupID: parseInt(customerDetail.groupID),
      factoryID: parseInt(customerDetail.factoryID),
      routeID: parseInt(customerDetail.routeID),
      applicableMonth: customerDetail.month === '' ? moment(new Date()).format('MM') : customerDetail.month,
      applicableYear: customerDetail.year === '' ? moment(new Date()).format('YYYY') : customerDetail.year,
      registrationNumber: customerDetail.registrationNumber,
    }
    getSelectedDropdownValuesForReport(model);
    const response = await services.getCustomerDetailsForBulkPrint(model);

    if (response.statusCode === "Success" && response.data != null) {
      if (response.data.length === 0) {
        alert.error("No records to display");
      } else {
        setCustomerData(response.data);
        setShowTable(true);

        // const allSameRegNumber = response.data.every(
        //   (item) => item.registrationNumber === response.data[0].registrationNumber
        // );

        // if (allSameRegNumber) {
        //   setCustomerName(response.data[0].customerName);
        // } else {
        //   setCustomerName("");
        // }
      }
    } else {
      setCustomerName("");
      alert.error("Error");
    }
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    let monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      routeName: routes[searchForm.routeID],
      month: monthNames[searchForm.applicableMonth - 1],
      year: searchForm.applicableYear,
      registrationNumber: searchForm.registrationNumber
    });
  }

  async function createDataForExcel(array) {
    var res = [];
    if (array != null) {
      array.map(x => {
        var vr = {
          'Date': new Date(x.cropCollectedDate).toLocaleDateString('en-CA'),
          'Super /Kg': x.superNetWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'Normal /Kg': x.normalNetWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
          'Total /Kg': (x.superNetWeight + x.normalNetWeight).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        };
        res.push(vr);
      });
    }
    res.push({});
    var totalsRow = {
      'Date': "Super Leaf Total /Kg : " + parseFloat(totals.superTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      'Super /Kg': "Normal Leaf Total /Kg : " + parseFloat(totals.normalTotal).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      'Normal /Kg': "Total Leaf /Kg : " + parseFloat(totals.totalWeight).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    };
    res.push(totalsRow);
    var vr = {
      'Date': "Group: " + selectedSearchValues.groupName,
      'Super  /Kg': "Factory: " + selectedSearchValues.factoryName,
      'Nromal /Kg': selectedSearchValues.routeName == undefined ? 'Route : All Routes' : 'Route : ' + selectedSearchValues.routeName,
    }
    res.push(vr)
    var vr2 = {
      'Date': "Registration Number: " + selectedSearchValues.registrationNumber,
      'Super  /Kg': "Customer Name: " + customerName,
    }
    res.push(vr2)
    var vr4 = {
      'Date': "Year and Month: " + selectedSearchValues.year + " - " + selectedSearchValues.month,
    }
    res.push(vr4)
    return res;
  }

  async function createFile() {
    var file = await createDataForExcel(customerData);
    var settings = {
      sheetName: 'Leaf Supplier Card Details Report',
      fileName:
        'Leaf Supplier Card Details Report ' +
        selectedSearchValues.factoryName +
        ' - ' +
        selectedSearchValues.groupName +
        ' ' +
        new Date(selectedDate).toLocaleString('en-US', { month: 'long' }) +
        ' - ' +
        new Date(selectedDate).getFullYear(),
      writeOptions: {}
    };

    let keys = Object.keys(file[0]);
    let tempcsvHeaders = [...csvHeaders];
    keys.forEach((sitem) => {
      tempcsvHeaders.push({ label: sitem, value: sitem });
    });

    let dataA = [
      {
        sheet: 'Supplier Card Details Report',
        columns: tempcsvHeaders,
        content: file
      }
    ];

    xlsx(dataA, settings);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setCustomerDetail({
      ...customerDetail,
      [e.target.name]: value
    });
    setCustomerName([]);
  }

  function handleDateChange(date) {
    var month = date.getUTCMonth() + 1;
    var year = date.getUTCFullYear();
    var currentmonth = moment().format('MM');

    setSelectedSearchValues({
      ...selectedSearchValues,
      month: month.toString(),
      year: year.toString()
    });

    setCustomerDetail({
      ...customerDetail,
      month: month.toString(),
      year: year.toString()
    });

    if (selectedDate != null) {

      var prevMonth = selectedDate.getUTCMonth() + 1
      var prevyear = selectedDate.getUTCFullYear();

      if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
        setSelectedDate(date)

      }
    } else {
      setSelectedDate(date)
    }
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  const handleKeyDownChange1 = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      getCustomerNameByCustomerID();
    }
  }

  const calculateTotals = () => {
    let superTotal = 0;
    let normalTotal = 0;

    customerData.forEach((data) => {
      superTotal += data.superNetWeight || 0;
      normalTotal += data.normalNetWeight || 0;
    });

    const totalWeight = (superTotal + normalTotal);
    return {
      superTotal: superTotal,
      normalTotal: normalTotal,
      totalWeight: totalWeight
    };
  };

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: customerDetail.groupID,
              factoryID: customerDetail.factoryID,
              routeID: customerDetail.routeID,
              registrationNumber: customerDetail.registrationNumber,
              year: customerDetail.year,
              month: customerDetail.month
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                // registrationNumber: Yup.string().required('Registration number is required').matches(/^[a-zA-Z0-9]{1,15}$/, 'Please enter valid registration number'),
              })
            }
            onSubmit={() => getCustomerDetails()}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <Divider />
                    <CardContent>
                      <Grid container spacing={4}>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="groupID">
                            Group *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.groupID && errors.groupID)}
                            fullWidth
                            helperText={touched.groupID && errors.groupID}
                            name="groupID"
                            onBlur={handleBlur}
                            onChange={(e) => handleChange(e)}
                            value={customerDetail.groupID}
                            variant="outlined"

                            size='small'
                            id="groupID"
                            disabled={!permissionList.isGroupFilterEnabled}
                          >
                            <MenuItem value="0">--Select Group--</MenuItem>
                            {generateDropDownMenu(GroupList)}
                          </TextField>
                        </Grid>

                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="factoryID">
                            Factory *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.factoryID && errors.factoryID)}
                            fullWidth
                            helperText={touched.factoryID && errors.factoryID}
                            name="factoryID"
                            onBlur={handleBlur}
                            onChange={(e) => handleChange(e)}
                            value={customerDetail.factoryID}
                            size='small'
                            variant="outlined"
                            id="factoryID"
                            disabled={!permissionList.isFactoryFilterEnabled}
                          >
                            <MenuItem value="0">--Select Factory--</MenuItem>
                            {generateDropDownMenu(FactoryList)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="routeID">
                            Route
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.routeID && errors.routeID)}
                            fullWidth
                            helperText={touched.routeID && errors.routeID}
                            name="routeID"
                            onChange={(e) => handleChange(e)}
                            value={customerDetail.routeID}
                            variant="outlined"
                            id="routeID"
                            size='small'
                          >
                            <MenuItem value="0">--Select Route--</MenuItem>
                            {generateDropDownMenu(routes)}
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="registrationNumberLbl">
                            Registration Number
                          </InputLabel>
                          <TextField
                            size='small'
                            error={Boolean(touched.registrationNumber && errors.registrationNumber)}
                            fullWidth
                            helperText={touched.registrationNumber && errors.registrationNumber}
                            name="registrationNumber"
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e)
                            }}
                            onKeyDown={(e) => handleKeyDownChange1(e)}
                            value={customerDetail.registrationNumber}
                            variant="outlined"
                            id="registrationNumber"
                          >
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12}>
                          <InputLabel shrink id="customerName">
                            Customer Name
                          </InputLabel>
                          <TextField
                            size='small'
                            error={Boolean(touched.customerName && errors.customerName)}
                            fullWidth
                            helperText={touched.customerName && errors.customerName}
                            name="customerName"
                            onBlur={handleBlur}
                            value={customerName}
                            variant="outlined"
                            id="customerName"
                            inputProps={{ readOnly: true }}
                          >
                          </TextField>
                        </Grid>
                        <Grid item md={3} xs={12} >
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <Box display="flex" width="100%">
                              <DatePicker
                                autoOk
                                variant="inline"
                                openTo="month"
                                views={["year", "month"]}
                                label="Year and Month *"
                                helperText="Select applicable month"
                                value={selectedDate}
                                disableFuture={true}
                                onChange={(date) => handleDateChange(date)}
                                size="small"
                              />
                            </Box>
                          </MuiPickersUtilsProvider>
                        </Grid>
                      </Grid>

                      <Box display="flex" flexDirection="row-reverse" p={2} >
                        <Button
                          color="primary"
                          type="submit"
                          variant="contained"
                          size='small'
                        >
                          Search
                        </Button>
                      </Box>
                    </CardContent>
                    <PerfectScrollbar>
                      <div style={{ overflow: 'auto' }}>
                        {customerData.length > 0 && showTable && (
                          <>
                            <Box
                              display="grid"
                              gridTemplateColumns="repeat(4, 1fr)"
                              gridGap={10}
                              sx={{
                                height: '1000px',  
                                overflow: 'auto'
                              }}
                            >
                              {Array(4).fill().map((_, columnIndex) => {
                                const daysData = groupDataByDay();
                                const { startDay, endDay } = getColumnDays(columnIndex);

                                return (
                                  <Box
                                    key={columnIndex}
                                    sx={{
                                      height: '100%',
                                      minHeight: '1000px',  
                                      display: 'flex',
                                      flexDirection: 'column',
                                      border: '1px solid #ccc',
                                      overflow: 'auto'
                                    }}
                                  >
                                    <table style={{
                                      width: '100%',
                                      flexGrow: 1
                                    }}>
                                      <thead>
                                        <tr>
                                          <th style={{ fontFamily: 'sans-serif', fontSize: '18px' }} className={classes.tableCell}>Day</th>
                                          <th style={{ fontFamily: 'sans-serif', fontSize: '18px' }} className={classes.tableCell}>Super /Kg</th>
                                          <th style={{ fontFamily: 'sans-serif', fontSize: '18px' }} className={classes.tableCell}>Normal /Kg</th>
                                          <th style={{ fontFamily: 'sans-serif', fontSize: '18px' }} className={classes.tableCell}>Total /Kg</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {Array.from({ length: 8 }, (_, rowIndex) => {
                                          const day = startDay + rowIndex;
                                          const dayEntries = daysData[day] || [];
                                          if (dayEntries.length === 0) {
                                            return (
                                              <tr key={day}>
                                                <td className={classes.tableCell}>{day}</td>
                                                <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'center' }} className={`${classes.tableCell} ${classes.totalCell}`}>--</td>
                                                <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'center' }} className={`${classes.tableCell} ${classes.totalCell}`}>--</td>
                                                <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'center' }} className={`${classes.tableCell} ${classes.totalCell}`}>--</td>
                                              </tr>
                                            );
                                          }
                                          return dayEntries.map((entry, entryIndex) => (
                                            <tr key={`${day}-${entryIndex}`}>
                                              <td className={classes.tableCell}>
                                                {entryIndex === 0 ? day : ''}
                                              </td>
                                              <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right' }} className={`${classes.tableCell} ${classes.totalCell}`}>
                                                <span style={{ fontSize: '18px' }}>
                                                  {entry.superNetWeight.toLocaleString('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                  })}
                                                </span>
                                              </td>
                                              <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right' }} className={`${classes.tableCell} ${classes.totalCell}`}>
                                                <span style={{ fontSize: '18px' }}>
                                                  {entry.normalNetWeight.toLocaleString('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                  })}
                                                </span>
                                              </td>
                                              <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right' }} className={`${classes.tableCell} ${classes.totalCell}`}>
                                                <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
                                                  {(entry.superNetWeight + entry.normalNetWeight).toLocaleString('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                  })}
                                                </span>
                                              </td>
                                            </tr>
                                          ));
                                        })}
                                      </tbody>
                                    </table>
                                  </Box>
                                );
                              })}
                            </Box>
                            <Box
                              mt={2}
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              gap={4}
                            >
                              <Chip
                                className={classes.chip}
                                size="small"
                                style={{ fontSize: '16px' }}
                                label={`Super Leaf Total /Kg : ${totals.superTotal !== undefined ? totals.superTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '--'}`}
                              />
                              <Chip
                                className={classes.chip}
                                size="small"
                                style={{ fontSize: '16px' }}
                                label={`Normal Leaf Total /Kg : ${totals.normalTotal !== undefined ? totals.normalTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '--'}`}
                              />
                              <Chip
                                className={classes.chip}
                                size="small"
                                style={{ fontSize: '16px' }}
                                label={`Total Leaf /Kg : ${totals.totalWeight !== undefined ? totals.totalWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '--'}`}
                              />
                            </Box>
                          </>
                        )}
                      </div>
                    </PerfectScrollbar>
                    {
                      customerData.length > 0 ?
                        <Box display='flex' justifyContent='flex-end' p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={() => createFile()}
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            trigger={() => <Button
                              color="primary"
                              id="btnCancel"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                              size='small'
                            >
                              PDF
                            </Button>}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF
                              ref={componentRef} data={customerDetail} searchData={selectedSearchValues} customerData={customerData} showTable={showTable} selectedDate={selectedDate} customerName={customerName} totals={totals}
                              groupDataByDay={groupDataByDay} getColumnDays={getColumnDays}

                            />
                          </div>
                        </Box> : null}
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}   